package com.fireavert.react.shared.components.cards

import com.fireavert.react.pages.administration.styles.AdministrationPageStyle
import mui.material.Skeleton
import mui.material.SkeletonVariant
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.router.dom.Link
import web.cssom.Color
import web.cssom.NamedColor

external interface AdminUseBoxesProps : Props {
    var boxTitle: String
    var boxValue: String
    var link: String
    var loading: Boolean
    var clickable: Boolean?
    var color: Color?
}

val AdminUserBoxes = FC<AdminUseBoxesProps> { props ->

    if (props.loading) {
        div {
            className = AdministrationPageStyle.adminUserBoxes(inputColor = null)
            Skeleton {
                variant = SkeletonVariant.rounded
                width = "100%"
                height = "100%"
            }
        }
    }
    else {
        Link {
            to = props.link
            div {
                className =
                    AdministrationPageStyle.adminUserBoxes(props.clickable ?: true, props.color ?: NamedColor.black)
                div {
                    className = AdministrationPageStyle.adminUserBoxTitle
                    +props.boxTitle
                }
                div {
                    className = AdministrationPageStyle.adminUserBoxValue(props.clickable ?: true)
                    +props.boxValue.toString()
                }
            }
        }
    }
}